// extracted by mini-css-extract-plugin
export default {"StatusMessageContainer":"StatusMessage_StatusMessageContainer__uoO9E","slidein":"StatusMessage_slidein__Ivm7x","CrossIcon":"StatusMessage_CrossIcon__6PMox"};